import React from 'react'
import Footer from '../Footer'
import ImageInkThree from '../ImageInkThree'

function ImgInkThree() {
    window.scrollTo(0,0);
    return (
        <>
            <ImageInkThree/>
            <Footer/>
        </>
    )
}

export default ImgInkThree
